import { Injectable } from '@angular/core';
import { FirebaseTSFirestore, Limit, OrderBy, Where } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { UserData } from '../models/user.model';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { FirebaseStorage } from 'firebase/storage'; 
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'; 


@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private firestore = new FirebaseTSFirestore();
  
  currentUserId = "";
  private listeners: { [key: string]: boolean } = {};

  openChats: UserData[] = []; 
  auth = new FirebaseTSAuth();

  constructor() { }


  

  

  

  // Fermer une fenêtre de chat
  closeChatWindow(userId: String): void {
    
    this.openChats = this.openChats.filter(openChat => openChat.uid !== userId);
  }

  closeChatWindow2(userId: String, listenerName: string): void {

    this.firestore.stopListeningTo(listenerName);
    //alert("window fermé!");
    this.openChats = this.openChats.filter(openChat => openChat.uid !== userId);
  }

  closeChatWindow3(userId: String, listenerName: string): void {

    this.firestore.stopListeningTo(listenerName);
    //alert("window fermé!");
    //this.openChats = this.openChats.filter(openChat => openChat.uid !== userId);
  }


  // Récupérer les messages de la discussion
  getMessages(currentUserId: string, selectedUserId: string, ): Promise<Message[]> {
    const listenerName = `GetChatMessages_${currentUserId}_${selectedUserId}`;
    return new Promise((resolve, reject) => {
      const messages: Message[] = [];

      this.firestore.listenToCollection({
        name: listenerName,
        path: ["Chats", this.getChatId(currentUserId, selectedUserId), "messages"],
        where: [
          new OrderBy("timestamp", "asc")
        ],
        onUpdate: (result) => {
          messages.length = 0;
          result.docs.forEach((doc) => {
            const message = doc.data() as Message;
            messages.push(message);
          });
          resolve(messages);
        },
        
      });
    });
  }

 

  // Récupérer les messages de la discussion
  getMessages2(currentUserId: string, selectedUserId: string, listenerName: string): Promise<Message[]> {
    //const listenerName = `GetChatMessages_${currentUserId}_${selectedUserId}`;
    return new Promise((resolve, reject) => {
      const messages: Message[] = [];

      this.firestore.listenToCollection({
        name: listenerName + Math.random(),
        path: ["Chats", this.getChatId(currentUserId, selectedUserId), "messages"],
        where: [
          new OrderBy("timestamp", "asc")
        ],
        onUpdate: (result) => {
          messages.length = 0;
          result.docs.forEach((doc) => {
            const message = doc.data() as Message;
            messages.push(message);
          });
          resolve(messages);
        },
        
      });
    });
  }

  // Envoyer un message
  sendMessage(currentUserId: string, selectedUserId: string, text: string): Promise<string> {
    const message: Message = {
      senderId: currentUserId,
      text: text,
      timestamp: new Date().toISOString(),
      receiverId: selectedUserId,
      read: false
    };

    const participants: String[] = [currentUserId, selectedUserId];

    this.firestore.create({
      path: ["Chats", this.getChatId(currentUserId, selectedUserId),],
      data: {
        id: this.getChatId(currentUserId, selectedUserId),
        participants: participants
      },
      onComplete: (result) => {
        console.log("successfully!");
      },
      onFail: (err) => console.error(err)
    });

    return this.firestore.create({
      path: ["Chats", this.getChatId(currentUserId, selectedUserId), "messages"],
      data: message,
      onComplete: (result) => {
        console.log("Message sent successfully!");
        
      },
      onFail: (err) => console.error(err)
    });
  }

  sendFile(currentUserId: string, selectedUserId: string, file: File): Promise<string> {
    // Obtenez une instance de Firebase Storage
    const storage = getStorage(); 
    const filePath = `Chats/${this.getChatId(currentUserId, selectedUserId)}/files/${file.name}`;
    const storageRef = ref(storage, filePath); // Créez une référence
  
    // Téléchargez le fichier
    return uploadBytes(storageRef, file).then(async (snapshot) => {
      // Récupérez l'URL du fichier téléchargé
      
      const fileUrl = await getDownloadURL(snapshot.ref);
      
      // Envoie le message avec l'URL appropriée
      const message: Message = {
        senderId: currentUserId,
        text: '',
        timestamp: new Date().toISOString(),
        imageUrl: file.type.startsWith('image/') ? fileUrl : null,
        audioUrl: file.type.startsWith('audio/') ? fileUrl : null,
        receiverId: selectedUserId,
        read: false
      };
  
      return this.firestore.create({
        path: ["Chats", this.getChatId(currentUserId, selectedUserId), "messages"],
        data: message,
        onComplete: (result) => {
          console.log("File sent successfully!");
        },
        onFail: (err) => console.error(err),
      });
    }).catch((error) => {
      console.error("Erreur lors de l'envoi du fichier:", error);
      throw error; // Rejeter la promesse en cas d'erreur
    });
  }

  

  async sendAudio(file: File, recipientId: string): Promise<void> {
    const storage = getStorage();
    const storageRef = ref(storage, `audio/${file.name}`);
  
    const snapshot = await uploadBytes(storageRef, file);
    const url = await getDownloadURL(snapshot.ref);
    // Stockez l'URL dans Firestore avec les autres informations de message
    const message = {
      senderId: this.auth.getAuth().currentUser.uid,
      audioUrl: url,
      text: '',
      timestamp: new Date().toISOString(),
      receiverId: recipientId
    };
    await this.firestore.create({
      path: ["Chats", this.getChatId(this.auth.getAuth().currentUser.uid, recipientId), "messages"],
      data: message
    });
    ;
  }
  
  // Générer l'ID de chat basé sur les deux IDs utilisateurs
  private getChatId(userId1: string, userId2: string): string {
    return userId1 < userId2 ? `${userId1}_${userId2}` : `${userId2}_${userId1}`;
  }
}

export interface Message {
  senderId: string;
  receiverId?: string;
  text: string;
  timestamp: string;
  imageUrl?: string;
  audioUrl?: string;
  read?: boolean; 
  readTimestamp?: string; 
}
